import React from 'react'
import FontDropDown from './FontDropDown'

function StylesSideNav() {
  return (
    <div className=' space-y-4 '>
    <div className="font-bold text-lg py-2 px-1">
    Gallery Styles
  </div>
        
 
<FontDropDown/>
 </div>
  )
}

export default StylesSideNav